import { render, staticRenderFns } from "./L01GPGPUParticle.vue?vue&type=template&id=c2816702&"
import script from "./L01GPGPUParticle.vue?vue&type=script&lang=js&"
export * from "./L01GPGPUParticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports